import { contentQueryResponse } from '..';
export const cbForContentQueryResponse = (contentChallenges) => contentQueryResponse(contentChallenges);
